module.exports = __webpack_public_path__ + "static/media/porsche-zoom2-_1_.05f0e3a2.jpg";